<template lang="html">
<section class="translation">
    <br>
    <div v-if="doShow && newer" v-for="(user,index) in users" class="Vlt-grid">
        <div class="Vlt-col Vlt-col--A-1of4">
            <vue-phone-number-input v-if="!index" :default-country-code="nexmo.region" v-model="users[index].pretty" @update="onUpdate1" />
            <vue-phone-number-input v-else :default-country-code="nexmo.region" v-model="users[index].pretty" @update="onUpdate2" />
        </div>
        <div class="Vlt-col Vlt-col--A-2of4">
            <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-2of4">
                    <div class="Vlt-native-dropdown">
                        <select class="inline" name="botSelect" id="botSelect" v-model="user.lang" @change="changeLang(index)">
                            <option v-for="lang in langs" :value="lang.code">{{lang.language}}</option>
                        </select>
                    </div>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">
                    <div class="Vlt-native-dropdown">
                        <select class="inline" name="botSelect" id="botSelect" v-model="user.greeting">
                            <option value="shortGreeting">Short Greeting</option>
                            <option value="standardGreeting">Standard Greeting</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <br><br><br>
    </div>
    <vlt-button v-if="newer" style="" label="Connect and Translate" quaternary app @click="connect" />
    <br><br>
    <div v-if="true" class="Vlt-grid">
        <div v-if="newer" class="Vlt-col Vlt-col--A-2of2">
            <div class="left"><span style="color:white; background-color: green"><b>{{' '+users[0].user}} ({{users[0].lang}})</b></span></div>
            <div class="center"><span style="color:blue; background-color: AntiqueWhite"><b> {{'Translations'}} </b></span></div>
            <div class="right"><b><span style="color:white; background-color: BlueViolet">{{users[1].user}} ({{users[1].lang}})</span></b></div>
            <br />
            <basic-vue-chat :useInput="Boolean(false)" class="Vlt-margin--top0 Vlt-margin--bottom1" :title="''" :new-message="message" />
        </div>
    </div>
</section>
</template>

<script lang="js">
import BasicVueChat from "@/components/chatter/src/components/basic-vue-chat/BasicVueChat";
import Pusher from "pusher-js";
import {
    $BASE,
    $NODEBASE
} from "@/base";
import {
    $HTTPDEMO,
    requestHandler
} from '@/services/nidsService.js';
import axios from 'axios';
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltCallout,
} from "@vonagevolta/vue";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
export default {
    name: 'translation',
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-callout": VltCallout,
        "basic-vue-chat": BasicVueChat,
        //        "font-awesome-icon": FontAwesomeIcon,
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        demoItem: {
            type: Object,
            required: false
        },
        baseLang: {
            type: Object,
            required: false
        },
        lang: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            NODEDEMO: {},
            postscript: "translation",
            newer: true,
            uuid: 0,
            pusher: {},
            channel: {},
            pchannel: "rt_interpreting",
            pevent: "transcript",
            message: {},
            users: [{
                    id: 0,
                    user: "Customer",
                    lang: "en-US",
                    voice: -1,
                    curLang: null,
                    phone: "",
                    pretty: "",
                    greeting: "shortGreeting",
                    valid: true,
                },
                {
                    id: 1,
                    user: "Agent",
                    lang: "es-MX",
                    voice: -1,
                    curLang: null,
                    phone: "",
                    pretty: "",
                    greeting: "shortGreeting",
                    valid: true,
                }
            ],
            cnt: 0,
            doShow: false,
            langs: [],
            logs: [],
            turl: "https://rti-sample-app.herokuapp.com/", //"https://tchan.ngrok.io/",
            chunks: [],
        }
    },
    methods: {
        getLanguages() {
            axios.get(this.turl + "langlist")
                .then(response => {
                    console.log("Voices/Languages: ", response.data);
                    let keys = Object.keys(response.data);
                    keys.forEach(key => {
                        let lang = {
                            code: key,
                            language: response.data[key]
                        }
                        this.langs.push(lang);
                        this.users.forEach(user => {
                            if (key == user.lang) {
                                user.curLang = lang;
                                console.log(`Setting current language for ${user.user} to `, lang)
                            }
                        })
                    })
                    console.log(this.langs);
                }).then(a => {
                    if (true || process.env.NODE_ENV === 'development') {
                        this.doShow = true;
                    }
                })
        },
        onUpdate1(payload) {
            console.log("onUpdate1 payload:", payload);
            if (!payload) return;
            if (payload.isValid) {
                this.users[0].phone = payload.formattedNumber.replace(/\D/g, '');
                console.log("Updated number: " + this.users[0].phone);
                //this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');
                this.users[0].valid = true;
            } else {
                this.users[0].valid = false;
            }
        },
        onUpdate2(payload) {
            console.log("onUpdate2 payload:", payload);
            if (!payload) return;
            if (payload.isValid) {
                this.users[1].phone = payload.formattedNumber.replace(/\D/g, '');
                console.log("Updated2 number: " + this.users[1].phone);
                this.users[1].valid = true;
                //this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');
            } else {
                this.users[1].valid = false;
            }

        },
        change() {
            console.log("Changed!")
        },
        onUpdate(index) {
            console.log("onUpdate: ", this.users[index].pretty);
        },
        connect() {
            if (!(this.users[0].valid) || !(this.users[1].valid)) {
                this.$swal('Warning',
                    `Both phone mumbers MUST be valid.`,
                    'warning');
                return;
            }
            let payload = [];
            this.users.forEach(user => {
                payload = {
                    type: "phone",
                    number: user.phone,
                    userId: user.id,
                    userName: user.user,
                    languageCode: user.lang,
                    //style: user.voice,
                    conferenceName: this.uuid,
                    conferencePin: this.nexmo.userid,
                    announcement: user.greeting,
                    auth: '',
                    x_custom_parameter_1: this.nexmo.userid,
                    x_custom_parameter_2: '',
                };
                console.log("Sending connect: ", payload);
                axios.post(this.turl + "placecall", payload)
                    .then((request) => console.log("Connection results: ", request.data))
                    .catch((err) => console.log(err));
                try {
                    this.NODEDEMO.post('/connection', {
                        payload: payload,
                    })
                } catch (e) {}
            })
        },
        changeLang(index) {
            this.langs.forEach(lang => {
                if (lang.code == this.users[index].lang) {
                    if (this.users[1 - index].curLang.code == lang.code) {
                        this.users[index].lang = this.users[index].curLang.code;
                        this.$swal('Warning',
                            `Both languages cannot be the same (${lang.code}).`,
                            'warning');
                    } else {
                        this.users[index].curLang = lang;
                        this.users[index].voice = -1;
                        console.log(`Setting curlang for ${index} to: `, lang)
                    }
                }
            })
        },
        processData(data) {
            if (data.confName != this.uuid) { // Not ours!  Ignore.
                return;
            }
            let say = {
                "vapiUuid": "388ff645-16a6-4522-bf03-d3ff1c9844c6",
                "chunkUuid": "9ee0e43f-3fa7-4266-9994-fa9317389866",
                "transcript": "How are you",
                "sourceLanguageCode": "es-MX",
                "userName": "User_2",
                "userId": "1",
                "confName": "2_1631738411",
                "x_custom_parameter_1": "2",
                "x_custom_parameter_2": "",
                "timestamp": 1631738452191
            };
            let hear = {
                "vapiUuid": "388ff645-16a6-4522-bf03-d3ff1c9844c6",
                "chunkUuid": "9ee0e43f-3fa7-4266-9994-fa9317389866",
                "translation": "How are you",
                "targetLanguageCode": "en-US",
                "userName": "User_2",
                "userId": "1",
                "confName": "2_1631738411",
                "x_custom_parameter_1": "2",
                "x_custom_parameter_2": "",
                "timestamp": 1631738452313
            }

            /*
            let data = {
                    user: 0,
                    lang: "en-US",
                    text: "Hello",
                    uuid: "1234",
                    timestamp: "07/12/2021 14:30:33",
                    original: true // Was this the original statement, or a translation?  translation=false
            }
            action: say | hear
            type (for hear): system | translation
            text
            uuid
            timestamp
            username
            id
            */
            let id = parseInt(data.userId);
            id = 1 - id;
            let date = new Date().toLocaleTimeString([], {
                hourCycle: 'h24'
            });
            let txt = "";
            let bubble = "AntiqueWhite"; //"AliceBlue";
            let color = 'margin-left: 30px;color:black; background-color: ' + bubble + '; font-weight: bold';
            if ("transcript" in data) {
                txt = data.transcript;
                if (id > 0) {
                    color = 'color:white; background-color: green; font-weight: bold';
                } else {
                    color = 'color:white; background-color: BlueViolet; font-weight: bold';
                }
            } else if ("translation" in data) {
                id = 1 - id; // Switch sides for the diplay...
                txt = data.translation;
                if (data.type && data.type == "system") {
                    color = 'margin-left: 40px;color:red; background-color: ' + bubble + '; font-weight: bold';
                } else {
                    if (id == 0) {
                        color = 'margin-right: 140px;color:green; background-color: ' + bubble + '; font-weight: bold';
                    } else {
                        color = 'margin-left: 140px;color:BlueViolet; background-color: ' + bubble + '; font-weight: bold';
                    }
                }
                //txt = "(" + data.
            } else {
                console.log("Invalid, neither trascription nor translation.");
                return;
            }
            if ((data.userId == -1) || txt.includes('Vonage Programmable Communications') || txt.includes('Ahora puedes hablar')) {
                txt = '(From System, in ' + data.sourceLanguageCode + ') ' + txt;
                color = 'margin-left: 40px;color:blue; background-color: ' + bubble + '; font-weight: bold';
            } else {

            }

            this.message = {
                id: id,
                author: '',
                contents: txt,
                date: date,
                msgstyle: color
            };
            console.log("Message: ", this.message);
            try {
                console.log("POSTing message");
                this.message.conferenceName = data.confName;
                this.NODEDEMO.post('/message', {
                    message: data,
                })
            } catch (e) {
                console.log("Error posting message")
            };
        },

    },
    created() {
        //console.log(this.nexmo);
        console.log("demoItem: ", this.demoItem);
        let obj = null;
        if (("requirements" in this.demoItem) && this.demoItem.requirements) {
            try {
                obj = JSON.parse(this.demoItem.requirements);
                console.log("Obj: ", obj);
                if (obj.url) {
                    this.turl = obj.url;
                    console.log("Setting URL to: " + this.turl);
                }
            } catch (e) {
                console.log("Error parsing json for demo requirements");
            }
        }
        this.uuid = "" + this.nexmo.userid + "_" + Math.floor(new Date().getTime() / 1000);
        this.users[0].phone = this.nexmo.phone;
        this.users[0].pretty = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        if (this.nexmo['info'] && this.nexmo['info'].phone2) {
            this.users[1].phone = this.nexmo['info'].phone2;
            this.users[1].pretty = parsePhoneNumberFromString("+" + this.nexmo['info'].phone2).formatNational();;
        } else {
            this.users[1].phone = this.users[0].phone;
            this.users[1].pretty = this.users[0].pretty;
        }
        if (obj && ("vcc" in obj)) {
            this.users[1].phone = obj.vcc;
            this.users[1].pretty = parsePhoneNumberFromString("+" + obj.vcc).formatNational();;
            console.log("Setting VCC as the second number: " + this.users[1].pretty);
        }
        this.NODEDEMO = axios.create({
            baseURL: $NODEBASE + '/' + this.postscript,
            headers: {
                "Content-Type": "application/json",
            },
        });
        this.NODEDEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        let pusher = new Pusher(this.nexmo.pusher_key, { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        this.pusher = pusher;
        this.channel = pusher.subscribe(this.pchannel);
        this.channel.bind(this.pevent, data => {
            console.log("Got some translation data: " + JSON.stringify(data));
            if ((!data.confName) || (data.confName != this.uuid)) { // Not ours!  Ignore.
                return;
            }
            if (!this.chunks[data.chunkUuid]) {
                this.chunks[data.chunkUuid] = {};
                if ("transcript" in data) {
                    this.chunks[data.chunkUuid].transcript = data;
                    this.processData(data); // Didn't already exist, so go ahead and process it
                } else {
                    this.chunks[data.chunkUuid].translation = data;
                }
            } else { // it DOES already exist...
                if ("transcript" in data) { // Ok, it already exists, but HERE is the transcript, meaning we already got a translation
                    console.log("************Adjusting Timing for Chunks!")
                    this.chunks[data.chunkUuid].transcript = data;
                    this.processData(data); // Send the transcription...
                    //Then send the translation...
                    this.$nextTick(() => {
                        this.processData(this.chunks[data.chunkUuid].translation); // Send the transcription...
                    })
                } else {
                    this.chunks[data.chunkUuid].translation = data;
                    this.processData(data); // Send the transcription...
                }
            }
            //this.processData(data);
        });
        this.getLanguages();
        /*
        axios.get("https://raw.githubusercontent.com/nexmo-community/vapi-tts-voices/main/voices.json")
            .then(response => {
                console.log("Voices/Languages: ", response.data);
                this.langs = response.data;
                this.langs.forEach(lang => {
                    this.users.forEach(user => {
                        if (lang.code == user.lang) {
                            user.curLang = lang;
                        }
                    })
                })
            }).then(a => {
                if (process.env.NODE_ENV === 'development') {
                    this.doShow = true;
                }
            })
            */
    },
    beforeDestroy() {
        console.log("beforeDestroy for translation demo")
        if (this.pusher) {
            this.pusher.unsubscribe(this.pchannel);
        }
    },
}
</script>

<style lang="scss" scoped>
.left {
  float: left;
}

.center {
  float: left;
  padding-left: 120px;
}

.right {
  float: left;
  padding-left: 110px;
}

.sel {
  padding: 5px;
  font-weight: bold;
}

.inline {
  display: inline-block;
  //padding-top: 10px;
  vertical-align: text-bottom;
  padding-left: 10px;
}

//@import "@basic-vue-chat/assets/scss/modules/_all.scss";

$primary: red;
$secondary: blue;
$header-color: blue;
$window-height: 200px;
// above the following import you can override default values of variables like $primary
</style>
